import React from 'react';
import * as S from './styles';
import { Link } from 'react-router-dom';

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
}

const Logo: React.FC<LogoProps> = ({ size = 'medium' }) => {
  return (
    <S.LogoContainer as={Link} to="/" size={size}>
      {size === 'small' ? (
        <S.LogoImage
          src="/logos/logotipo-ada-sistemas-03.png"
          alt="ADA Sistemas Logo"
        />
      ) : (
        <S.LogoImage
          src="/logos/logotipo-ada-sistemas-04.png"
          alt="ADA Sistemas Logo Completo"
        />
      )}
    </S.LogoContainer>
  );
};

export default Logo;
